(function () {
  console.log("[Gift DEBUG] Script loaded");

  const originalFetch = window.fetch;
  let isAddingGift = false;

  window.fetch = async function (...args) {
    const [url, config] = args;

    const isCartAdd = typeof url === "string" && url.includes("/cart/add");

    let ids = []; // ✅ declarar UNA sola vez aquí
    let isTriggerProduct = false;

    if (isCartAdd) {
      console.log("[Gift DEBUG] Detected /cart/add call");
    }

    if (isCartAdd && config?.body) {
      try {
        if (config.body instanceof FormData) {
          console.log("[Gift DEBUG] Body is FormData");

          const id = config.body.get("id");
          if (id) ids.push(Number(id));
        } else {
          console.log("[Gift DEBUG] Body is JSON");

          const body = JSON.parse(config.body);

          ids = Array.isArray(body.items)
            ? body.items.map((i) => i.id)
            : [body.id];
        }

        console.log("[Gift DEBUG] IDs detected:", ids);

        const TRIGGER_VARIANT_ID = 53349596037393;

        isTriggerProduct = ids.includes(TRIGGER_VARIANT_ID);

        if (isTriggerProduct) {
          console.log("[Gift DEBUG] ✅ Trigger product detected");
        } else {
          console.log("[Gift DEBUG] ❌ Not trigger product");
        }
      } catch (e) {
        console.log("[Gift DEBUG] Error parsing body", e);
      }
    }

    // 👉 Ejecutar request original
    const response = await originalFetch.apply(this, args);

    // 🎁 Agregar regalo
    if (isCartAdd && isTriggerProduct && !isAddingGift) {
      console.log("[Gift DEBUG] 🎁 Adding gift...");

      isAddingGift = true;

      try {
        const cart = await fetch("/cart.js").then((r) => r.json());

        const GIFT_VARIANT_ID = 53346363867409;

        const hasGift = cart.items.some(
          (item) => item.variant_id === GIFT_VARIANT_ID,
        );

        console.log("[Gift DEBUG] Has gift?", hasGift);

        if (!hasGift) {
          console.log("[Gift DEBUG] ➕ Sending add gift request");

          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: GIFT_VARIANT_ID,
              quantity: 1,
            }),
          });
        }
      } catch (err) {
        console.error("[Gift DEBUG] Gift error:", err);
      } finally {
        setTimeout(() => {
          isAddingGift = false;
          console.log("[Gift DEBUG] 🔓 Unlock");
        }, 500);
      }
    }

    return response;
  };
})();
